export default __webpack_public_path__ + "static/media/new-sc-logo-no-background.2aac249a.svg";